$(function () {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-extra="tooltip"]').tooltip();
})
